$('#feelFreeToContactUsButton').on('click', function () {
    let fullName = $('.feel-free-home .fullName').val(),
        organisationName = $('.feel-free-home .organisationName').val(),
        email = $('.feel-free-home .email').val(),
        phone = $('.feel-free-home .phone').val(),
        message = $('.feel-free-home .message').val();

    if (!$('.invalid-feedback').is(':visible')) {
        $.ajax({
            url: $('#ajax_url').val(),
            type: "POST",
            cache: false,
            data: {
                action: 'feel_free_to_contact_us_home_form',
                fullName: fullName,
                organisationName: organisationName,
                email: email,
                phone: phone,
                message: message,
            },
            success: function (res) {
                successSend(res);
            }
        });
    }

    return false;
});
